import {
  IModel,
  Model,
  PetModel,
  DiagnosisModel,
  VisitModel,
  ModelRecord,
  IVisitModel,
  DiagnosisStatusModel,
  PetDiagnosisStatusHistoryModel,
  IPetDiagnosisStatusHistoryModel,
} from '@common/models';
import { makeObservable, observable } from 'mobx';
export interface IPetDiagnosisModel extends IModel {
  petDiagnosisId: number;
  petId: number;
  diagnosisId: number;
  diagnosisStatusId: number;
  visitId: number | null;
  pet: PetModel;
  diagnosis: DiagnosisModel;
  diagnosisStatus: DiagnosisStatusModel;
  dateCreated: string;
  dateDiagnosed: string;
  visit: IVisitModel;
  latestPetDiagnosisStatus: IPetDiagnosisStatusHistoryModel;
}

export class PetDiagnosisModel
  extends Model
  implements ModelRecord<IPetDiagnosisModel>
{
  @observable petDiagnosisId: number;
  @observable petId: number;
  @observable diagnosisId: number;
  @observable diagnosisStatusId: number;
  @observable visitId: number | null;
  @observable pet: PetModel;
  @observable diagnosis: DiagnosisModel;
  @observable diagnosisStatus: DiagnosisStatusModel;
  @observable dateCreated: string;
  @observable dateDiagnosed: string;
  @observable visit: VisitModel;
  @observable latestPetDiagnosisStatus: PetDiagnosisStatusHistoryModel;
  constructor(params: IPetDiagnosisModel) {
    super(params);
    this.petDiagnosisId = _.defaultTo(params.petDiagnosisId, 0);
    this.petId = _.defaultTo(params.petId, 0);
    this.diagnosisId = _.defaultTo(params.diagnosisId, 0);
    this.diagnosisStatusId = _.defaultTo(params.diagnosisStatusId, 0);
    this.visitId = _.defaultTo(params.visitId, null);
    this.pet = params?.pet ? new PetModel(params?.pet) : new PetModel();
    this.diagnosis = params.diagnosis
      ? new DiagnosisModel(params.diagnosis)
      : new DiagnosisModel();
    this.diagnosisStatus = new DiagnosisStatusModel(params.diagnosisStatus);
    this.dateCreated = _.defaultTo(params.dateCreated, '');
    this.visit = params.visit && new VisitModel(params.visit);
    this.latestPetDiagnosisStatus =
      params.latestPetDiagnosisStatus &&
      new PetDiagnosisStatusHistoryModel(params.latestPetDiagnosisStatus);
    this.dateDiagnosed = _.defaultTo(params.dateDiagnosed, '');
    makeObservable(this);
  }
}
